import React, { useState } from 'react';
import { InlineNotification, Text } from '@ui';
import { PushGatesCard } from './PushGatesCard';
import { PushHistoryTable } from './PushHistoryTable';
import { PushHistoryToolbar } from './PushHistoryToolbar';
import { formatDate, formatDateTime } from './format';
import { rowMatchesFilter, t } from './labels';
import './PushHistoryStyles.scss';
function DeviceChip({ device, timeZone }) {
    var _a;
    const registered = device.state === 'registered';
    const label = registered
        ? t('device.registered', { model: (_a = device.deviceModel) !== null && _a !== void 0 ? _a : '—', date: formatDate(device.registeredAt, timeZone) })
        : t(device.state === 'none' ? 'device.none' : 'device.unknown');
    return (React.createElement("span", { className: "push-history__device" },
        React.createElement("span", { className: registered ? 'push-history__dot' : 'push-history__dot push-history__dot--off' }),
        React.createElement(Text, { variant: "xx-small" }, label)));
}
function SourceKey() {
    return (React.createElement("div", { className: "push-history__key" }, ['rails', 'platform', 'join'].map((side) => (React.createElement("span", { key: side },
        React.createElement("i", { className: `push-history__swatch push-history__swatch--${side}` }),
        React.createElement(Text, { variant: "xx-small" }, t(`key.${side}`)))))));
}
/**
 * Employee-only push history: what Rails decided for a technician joined to what the
 * notification platform did with it, one row per push, plus the switches a push passes.
 */
export function PushHistory({ technicianName, timeZone, since, capped, platform, device, gates, rows }) {
    const [filter, setFilter] = useState('all');
    const [tinted, setTinted] = useState(true);
    const [expanded, setExpanded] = useState({});
    const visibleRows = rows.filter((row) => rowMatchesFilter(row, filter));
    const toggleRow = (rowId) => setExpanded((current) => (Object.assign(Object.assign({}, current), { [rowId]: !current[rowId] })));
    return (React.createElement("div", { className: "push-history" },
        React.createElement("div", { className: "push-history__intro" },
            React.createElement(Text, { variant: "body", as: "p", className: "push-history__muted" }, t('tip')),
            React.createElement(DeviceChip, { device: device, timeZone: timeZone })),
        React.createElement(PushGatesCard, { technicianName: technicianName, gates: gates }),
        platform.unavailable && (React.createElement(InlineNotification, { variant: "warning", title: t('banner.title') },
            React.createElement(Text, { variant: "body" }, platform.health),
            platform.error && React.createElement("code", { className: "push-history__banner-error" }, platform.error))),
        React.createElement(Text, { variant: "body", as: "p", className: "push-history__window" },
            t('window', { date: formatDateTime(since, timeZone) }),
            capped && ` ${t('window_capped')}`),
        React.createElement(PushHistoryToolbar, { rows: rows, filter: filter, onFilterChange: setFilter, tinted: tinted, onTintedChange: setTinted, platformUnavailable: platform.unavailable }),
        visibleRows.length === 0 ? (React.createElement(Text, { variant: "body", as: "p", className: "push-history__empty" }, t(rows.length === 0 ? 'empty' : 'empty_filter'))) : (React.createElement(PushHistoryTable, { rows: visibleRows, timeZone: timeZone, platformUnavailable: platform.unavailable, tinted: tinted, expanded: expanded, onToggleRow: toggleRow })),
        React.createElement(SourceKey, null)));
}
export default PushHistory;
